module.exports = __webpack_public_path__ + "img/sign_250890871_1.aeb54420.png";